type IcPlusProps = {
  fill?: string
  width?: number
  height?: number
}

export default function IcPlus({ fill = '#fff', width = 8, height = 8 }: IcPlusProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 8 8"
      fill="none"
    >
      <path
        d="M4 1V7M7 4H1"
        stroke={fill}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
